import { useEffect } from "react";

import useLatest from "@src/shared/hooks/useLatest";

import { AppBusEvents, appBus } from "../../events/bus";

export function useAppBusEvent<K extends keyof AppBusEvents>(
  event: K,
  handler: (data: AppBusEvents[K]) => void,
) {
  const latestHandler = useLatest(handler);

  // biome-ignore lint/correctness/useExhaustiveDependencies: latestHandler keeps the subscribed listener current without resubscribing.
  useEffect(() => {
    const listener = (data: AppBusEvents[K]) => {
      latestHandler.current(data);
    };

    appBus.on(event, listener);

    return () => {
      appBus.off(event, listener);
    };
  }, [event]);
}
